<template>
  <b-button
    variant="outline-success"
    size="sm"
    class="defective-slip-export-btn font-weight-bolder"
    :disabled="!stockSlipId || isExporting"
    @click="exportExcel"
  >
    <b-spinner v-if="isExporting" small class="mr-1"></b-spinner>
    <i v-else class="far fa-file-excel defective-slip-export-btn__icon"></i>
    {{ isExporting ? 'Đang xuất...' : 'Xuất Excel' }}
  </b-button>
</template>

<script>
import { downloadDefectiveStockSlipDocument } from '@/utils/export-defective-stock-slip';

export default {
  name: 'DefectiveStockSlipExportButton',
  props: {
    stockSlipId: {
      type: [Number, String],
      default: null,
    },
    stockSlipCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isExporting: false,
    };
  },
  methods: {
    async exportExcel() {
      const stockSlipId = this.stockSlipId;
      if (!stockSlipId || this.isExporting) return;

      this.isExporting = true;
      try {
        await downloadDefectiveStockSlipDocument(stockSlipId, this.stockSlipCode);
      } catch {
        this.$bvToast.toast('Xuất Excel thất bại, vui lòng thử lại.', {
          title: 'Lỗi',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<style scoped>
.defective-slip-export-btn {
  width: max-content;
  flex-shrink: 0;
  white-space: nowrap;
  vertical-align: middle;
}

.defective-slip-export-btn__icon {
  font-size: 1rem;
  margin-right: 0.25rem;
}
</style>
